import { useContext } from 'react';

import Context from './Context';

function useEnvConfig() {
  return useContext(Context);
}

export default useEnvConfig;
